import { render, staticRenderFns } from "./ComplaintMedia.vue?vue&type=template&id=f5b0f960&"
import script from "./ComplaintMedia.vue?vue&type=script&lang=js&"
export * from "./ComplaintMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports